import { motion } from "framer-motion";

export default function PhotoGallery({ data }) {
  const images = data.images || [];
  return (
    <section id="gallery" data-testid="photo-gallery-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="overline mb-4" data-testid="photo-gallery-overline">{data.overline}</p>
            <h2
              data-testid="photo-gallery-title"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-onyx"
            >
              {data.title}
            </h2>
          </div>
          {data.subtitle && (
            <p className="text-onyx/60 max-w-md md:text-right">{data.subtitle}</p>
          )}
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[260px]">
          {images.map((img, i) => {
            const span =
              i === 0
                ? "md:col-span-2 md:row-span-2"
                : i === 3
                ? "md:col-span-2"
                : i === 4
                ? "row-span-2"
                : "";
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                data-testid={`photo-${i}`}
                className={`relative overflow-hidden group ${span}`}
              >
                <img
                  src={img.url}
                  alt={img.alt || `Foto ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-onyx/0 group-hover:bg-onyx/20 transition-colors" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
